export default __webpack_public_path__ + "static/media/history-card.1cdfd352.webp";